module.exports = __webpack_public_path__ + "img/hs_code.f06aa109.svg";